import { Panel } from "components/Panel/Panel";
import { selectNonCompletedMatches } from "selectors/Match";
import { EmptyGrowPanelText } from "styles/text";
import { UpcomingMatches } from "./UpcomingMatches";
import { useAppSelector } from "app/hooks";

interface Props {
  matchIds: string[];
  showTrackScores: boolean;
  hoverColor?: string;
}

export const UpcomingMatchesIds = ({
  matchIds,
  showTrackScores,
  hoverColor,
}: Props) => {
  const upcomingMatches = useAppSelector((state) =>
    selectNonCompletedMatches(state, matchIds)
  );

  if (upcomingMatches.length === 0) {
    return (
      <Panel>
        <EmptyGrowPanelText>No Upcoming Matches</EmptyGrowPanelText>
      </Panel>
    );
  }

  return (
    <UpcomingMatches
      matches={upcomingMatches}
      showTrackScores={showTrackScores}
      hoverColor={hoverColor}
    />
  );
};
